import DocumentService from '../../services/DocumentService.js'

export const namespaced = true

export const state = {
  documents: [],
  document: {}
}

export const mutations = {
  ADD_DOCUMENT(state, document) {
    state.documents.push(document)
  },
  SET_DOCUMENTS(state, documents) {
    state.documents = documents
  },
  SET_DOCUMENT(state, document) {
    state.document = document
  },
  UPDATE_DOCUMENT(state, document) {
    state.documents = [...state.documents.filter(d => d.documentID !== document.documentID), document]
  },
  DELETE_DOCUMENT(state, id) {
    state.documents = [...state.documents.filter(d => d.documentID !== id)]
  }
}

export const actions = {
  save({ commit }, document) {
    if (document.documentID) {
      return new Promise((resolve, reject) => {
        reject('You cannot update existing documents')
      })
    } else {
      return DocumentService.post(document).then(res => {
        const d = res.data
        commit('ADD_DOCUMENT', d)
        commit('SET_DOCUMENT', d)
      })
    }
  },
  delete({ commit }, id) {
    return DocumentService.delete(id).then(() => {
      commit('DELETE_DOCUMENT', id)
    })    
  },
  getByEntity({ commit }, id) {
    return DocumentService.getByEntity(id).then(res => {
      commit('SET_DOCUMENTS', res.data)
    })
  },
  set({ commit }, id) {
    return new Promise((resolve, reject) => {
      const document = state.documents.find(d => d.documentID == id)
      if (!document) return reject()
      commit('SET_DOCUMENT', document)
      resolve(document)
    })
  },
  clearDocument({ commit }) {
    return new Promise(resolve => {
      commit('SET_DOCUMENT', {})
      resolve()
    })
  },
  clear({ commit }) {
    return new Promise(resolve => {
      commit('SET_DOCUMENT', {})
      commit('SET_DOCUMENTS', [])
      resolve()
    })
  },
  setDocuments({ commit }, documents) {
    return new Promise(resolve => {
      commit('SET_DOCUMENTS', documents)
      resolve()
    })
  },
  add({ commit }, document) {
    return new Promise(resolve => {
      commit('ADD_DOCUMENT', document)
      resolve()
    })
  }
}

export const getters = {
  documentsForChange: (state, getters, rootState) => state.documents.filter(d => d.changeID == rootState.change.change.changeID && !d.syncID && !d.officerID),
  officerDocument: (state, getters, rootState) => rootState.officer.officers.find(o => (o.entityID == rootState.entity.entity.entityID) && o.documentID)
}